(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name cabinPerformance.controller:CabinPerformanceCtrl
   *
   * @description
   *
   */
  angular
    .module('cabinPerformance')
    .controller('CabinPerformanceCtrl', CabinPerformanceCtrl);

  function CabinPerformanceCtrl(CommonMasterData, $sce,CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'CabinPerformanceCtrl';
    vm.model = {
      searchPanelToggle : true,
      searchCriteria : {
        fromDate : null,
        toDate : null,
        crewType : null,
        crewId : null,
        reportFormat : true
      },
      masterList : {
        crewTypes : [],
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false,
        fromDateAfterToDate : false,
        isToDateFutureDate : false,
        crewIdInvalid : false
      },
      initialSearchDone : false,
      reportDataURL : null,
      reportServerBaseUrl : null
    };

    // toggle search
    vm.clickOnSearch = function() {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    // submit search
    vm.submitSearch = function(params) {
      searchCrewSignInReport(params);
    };

    // on change search field
    vm.changeSearchField = function() {
      setDateValidationFlags();
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid
        && !vm.model.masterList.isToDateFutureDate) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;
        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }
    };

    function setDateValidationFlags() {
      // if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      // if to date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
        vm.model.masterList.isToDateFutureDate = false;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
        if (!!vm.model.searchCriteria.toDate) {
          vm.model.masterList.isToDateFutureDate = istoDateFutureDate();
        } else {
          vm.model.masterList.isToDateFutureDate = false;
        }
      }
    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    // check from date and to date
    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    }
    ;

    // check to date is a future date
    function istoDateFutureDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isAfter(moment().toDate());
    }
    ;


    function searchCrewSignInReport(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;
        var rptDesign = "";
        if(vm.model.searchCriteria.reportFormat){
          rptDesign = "cabin_performance_table_report.rptdesign";
        }else {
          rptDesign = "cabin_performance_graph_report.rptdesign";
        }

        var url = CommonLogicService.getReportUrl(rptDesign, getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url)
      }
    }

    // set search param map
    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;
      if (!!param.crewId) {
        searchParamMap["crewId"] = param.crewId;
      }
      if (!!param.crewType && !!param.crewType.crewTypeCode) {
        searchParamMap["crewType"] = param.crewType.crewTypeCode;
      }
      return searchParamMap;
    }

    function isValidSearchParams(params) {
      setDateValidationFlags();
      // if date invalid
      if (vm.model.masterList.toDateFormatInvalid
        || vm.model.masterList.fromDateFormatInvalid
        || vm.model.masterList.isToDateFutureDate) {
        vm.model.masterList.crewIdInvalid=false;
        return false;
      } else if (istoDateBeforeFromDate()) {
        vm.model.masterList.fromDateAfterToDate = true;
        vm.model.masterList.crewIdInvalid=false;
        return false;
      } else {
        if(!vm.model.searchCriteria.reportFormat && !vm.model.searchCriteria.crewId){
          vm.model.masterList.crewIdInvalid=true;
          return false;
        }
        vm.model.masterList.crewIdInvalid=false;
        return true;
      }
    }
    ( // load crew Types
      function loadCrewTypes() {
        CommonMasterData.getCrewTypeList(function(crewTypes) {
          vm.model.masterList.crewTypes = crewTypes;
        }, function() {
          console.log('Crew type retrieval error');
        });
      })();
  }
}());
